export interface NotificationTypeMeta {
  icon: string;
  chip: string;
  dot: string;
}

export const NOTIFICATION_TYPE_META: Record<string, NotificationTypeMeta> = {
  info: {
    icon: "ri-information-line",
    chip: "bg-secondary-100 text-secondary-900",
    dot: "bg-secondary-500",
  },
  success: {
    icon: "ri-checkbox-circle-line",
    chip: "bg-primary-100 text-primary-700",
    dot: "bg-primary-500",
  },
  warning: {
    icon: "ri-alert-line",
    chip: "bg-accent-100 text-accent-700",
    dot: "bg-accent-500",
  },
  error: {
    icon: "ri-error-warning-line",
    chip: "bg-accent-100 text-accent-700",
    dot: "bg-accent-600",
  },
};

export function notificationMeta(type: string): NotificationTypeMeta {
  return NOTIFICATION_TYPE_META[type] ?? NOTIFICATION_TYPE_META.info;
}